import Layout from "comps/Layout"
import ShopCategoryContentH5 from "comps/ShopCategoryContentH5"
import { SiteContext } from "libs/contexts"
import { CategoryPageData } from "pages/shop/category/[id]"
import { useContext } from "react"

export default function ShopCategory(props: CategoryPageData) {
  const site = useContext(SiteContext)

  return (
    <Layout
      header={null}
      footer={null}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description={`${
        site.basic?.tenantName || ""
      }通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
    >
      <ShopCategoryContentH5 {...props} />
    </Layout>
  )
}
